import React from "react";

import "./ProcessSection.scss";

interface Phase {
  number: string;
  title: string;
  description: string;
  deliverables: string[];
}

interface ProcessSectionProps {
  title?: string;
  description?: string;
  phases: Phase[];
}

export function ProcessSection({
  phases,
  description,
  title,
}: ProcessSectionProps) {
  return (
    <section className="processSection">
      <div className="processContainer">
        <div className="processHeader">
          <h2 className="processTitle">{title}</h2>
          <p className="processDescription">{description}</p>
        </div>

        <div className="processPhases">
          {phases.map((phase, index) => (
            <div key={index} className="phaseItem">
              <div className="phaseContent">
                {/* Number */}
                <div className="phaseNumberWrapper">
                  <div className="phaseNumber">{phase.number}</div>
                </div>
                {/* Content */}
                <div className="phaseDetails">
                  <h3 className="phaseTitle">{phase.title}</h3>
                  <p className="phaseDescription">{phase.description}</p>
                  <div className="phaseDeliverables">
                    {phase.deliverables.map((deliverable, idx) => (
                      <span key={idx} className="deliverableTag">
                        {deliverable}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
              {/* Connector line*/}
              {index < phases.length - 1 && (
                <div className="phaseConnector"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
